"use client";

import React from "react";
import type { TagKey } from "@/content/types";
import type { GalleryFilterProviderProps } from "../types";
import GalleryFilterContext from "./context";

function GalleryFilterProvider({ children }: GalleryFilterProviderProps) {
  const [selectedTags, setSelectedTags] = React.useState(new Set<string>());

  const toggleTag = React.useCallback((tag: TagKey, checked: boolean) => {
    setSelectedTags(prev => {
      const next = new Set(prev);

      checked ? next.add(tag) : next.delete(tag);

      return next;
    });
  }, []);

  const context = React.useMemo(
    () => ({ selectedTags, toggleTag }),
    [selectedTags, toggleTag],
  );

  return (
    <GalleryFilterContext.Provider value={context}>
      {children}
    </GalleryFilterContext.Provider>
  );
}

export default GalleryFilterProvider;
